import React, { useState } from 'react';
import { Typography, Container, Box } from '@mui/material';
import StyledButton from './StyledButton';
import ImageComponent from './ImageComponent';

const IntroComponent = ({ navigate }) => {
    const [isLoading, setIsLoading] = useState(true);
    const startQuiz = () => {
        navigate('/questions/1');
    };

    const handleImageLoad = () => {
        setIsLoading(false);
    };

    return (
        <>
            <Box width="100vw" maxWidth="100%" overflow="hidden" position="relative" left="50%" right="50%" marginLeft="-50vw" marginRight="-50vw">
                <ImageComponent
                    src="/quizzes/personality/assets/images/introduction/argo-x-identity.webp"
                    alt="Illustration representing the theme of discovering your innovation identity with argodesign"
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    onLoad={handleImageLoad}
                />

            </Box>
            <Container maxWidth="sm">
                <Box display="flex" flexDirection="column" alignItems="center" mx={4} mt={4} mb={16}>
                    <Typography variant="h3" align="left" mt={4} gutterBottom>
                        What's Your Innovation Identity?
                    </Typography>
                    <Typography variant="h5" align="left" gutterBottom>
                        Let's embark on a design journey to find your product persona. Discover your business's unique personality and find out how argodesign can help you shape the future.
                    </Typography>
                    <Box mt={4} width="100%">
                        <StyledButton onClick={startQuiz}>
                            Get Started!
                        </StyledButton>
                    </Box>
                </Box>
            </Container>
        </>
    );
};

export default IntroComponent;
